module.exports = __webpack_public_path__ + "img/school3.99b2b126.jpeg";